// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/**
 * Disables the given animated property under `prefers-reduced-motion: reduce`.
 *
 * @param property the animated CSS property to turn off (defaults to `transition`)
 * @returns css disabling that property for users who've opted out of motion
 */
export const reducedMotionStyles = (property: "transition" | "animation" = "transition") => {
    return css`
        @media (prefers-reduced-motion: reduce) {
            ${property}: none;
        }
    `;
};

/**
 * Only for Chrome
 *
 * @returns css for a scrollbar
 */
export const scrollbarStyles = () => {
    return css`
        &::-webkit-scrollbar {
            width: ${pxToRem(10)};
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: ${getColor("common.disabledDark")};
            border-radius: ${pxToRem(5)};
        }

        &::-webkit-scrollbar-thumb:hover {
            background: ${getColor("common.accentContrast")};
        }
    `;
};
